import React from "react";
import "./icon-button.css";

interface Props {
  ariaLabel: string;
  onClick?: () => void;
  children: React.ReactNode;
  tooltip?: string;
  className?: string;
  disabled?: boolean;
}

function IconButton({
  ariaLabel,
  onClick,
  children,
  tooltip,
  className = "",
  disabled,
}: Props) {
  return (
    <button
      className={`v1-ico-btn${className ? ` ${className}` : ""}`}
      aria-label={ariaLabel}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
      {tooltip && <span className="v1-ico-btn-tooltip">{tooltip}</span>}
    </button>
  );
}

export default IconButton;
